import { buildFamsMenuMessages } from 'config/fams-menu';

export default {
  'menu.login': 'ログイン',
  'menu.account': 'アカウント',
  'menu.account.center': '個人設定',
  'menu.account.workbench': 'ワークベンチへ戻る',
  'menu.account.tenantManagement': 'テナント管理',
  'menu.account.logout': 'ログアウト',
  ...buildFamsMenuMessages('ja-JP'),
};
